(() => {
  if (window.__AW_PRODUCT_RECOMMENDATIONS_ACTIVE__) return;
  window.__AW_PRODUCT_RECOMMENDATIONS_ACTIVE__ = true;

  const selector = '[data-product-recommendations], [data-aw-complementary-products]';

  const hasServerApprovedCards = (section) => Boolean(
    section.querySelector('[data-aw-recommendation-card]')
  );

  const getRecommendationsUrl = (section) => (
    section?.dataset?.url || section?.querySelector?.('[data-url]')?.dataset?.url || ''
  );

  const getReplacement = (wrapper, section) => {
    if (section.matches?.('[data-aw-complementary-products]')) {
      return wrapper.querySelector('[data-aw-complementary-products]');
    }

    if (section.id) {
      const exact = wrapper.querySelector(`#${CSS.escape(section.id)}`);
      if (exact) return exact;
    }

    return wrapper.querySelector('[data-product-recommendations]');
  };

  const notifyLoaded = (section) => {
    document.dispatchEvent(new CustomEvent('recommendations:loaded', {
      detail: {
        section,
        sectionId: section.id || section.dataset.sectionId || ''
      }
    }));
  };

  const loadRecommendations = async (section) => {
    const url = getRecommendationsUrl(section);
    if (!section || !url || section.dataset.loaded === 'true') return;

    if (section.matches?.('[data-aw-multisource-general-p1]') && hasServerApprovedCards(section)) {
      section.dataset.loaded = 'true';
      notifyLoaded(section);
      return;
    }

    section.dataset.loaded = 'true';

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const wrapper = document.createElement('div');
      wrapper.innerHTML = await response.text();
      const replacement = getReplacement(wrapper, section);

      if (!replacement || !replacement.innerHTML.trim() || !hasServerApprovedCards(replacement)) {
        section.remove();
        return;
      }

      section.innerHTML = replacement.innerHTML;
      notifyLoaded(section);
    } catch (_) {
      section.remove();
    }
  };

  const init = (root = document) => {
    if (root.matches?.(selector)) loadRecommendations(root);
    root.querySelectorAll?.(selector).forEach((section) => loadRecommendations(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();